export const StockInModeEnum = Object.freeze({
  FULL: "FULL",
  PARTIAL: "PARTIAL",
  NONE: "NONE",
});
